import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { performApiRequest, getResultData, invalidateApiDataRequest, getApiDataRequest } from '../../redux/apiData';
import { clearModalState, updateModalOpenState, openModal } from '../../redux/modal';
import withApiData from '../../services/withApiData';
import moment from 'moment';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
import { isDateExpired } from '@/processes/dateTime';

// Components
import Paragraph from '../shared/richText/Paragraph';
import Input from '../shared/forms/fieldTypes/Input';
import ButtonPrimary from '../shared/buttons/ButtonPrimary';
import CheckIcon from '../shared/icons/Check';

// Styles
import { colorPalette, shadows, textStyles } from '../../styles/styleGuide';
import { fromBreakpoint } from '../../styles/breakpoints';
var connectApiData = withApiData({
  verificationStatus: 'getVerificationStatus'
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postOptionOrderRequest: getApiDataRequest(state.apiData, 'postOptionOrder', {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    }),
    verificationToken: getResultData(state.apiData, 'getVerificationToken'),
    postVerificationRequest: getApiDataRequest(state.apiData, 'postVerificationToken')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    wishListId = _ownProps$match$param.wishListId;
  return {
    getVerificationToken: function getVerificationToken() {
      dispatch(invalidateApiDataRequest('postVerificationToken'));
      dispatch(invalidateApiDataRequest('getVerificationToken'));
      dispatch(performApiRequest('getVerificationToken'));
    },
    getVerificationStatus: function getVerificationStatus() {
      dispatch(invalidateApiDataRequest('getVerificationStatus'));
      dispatch(performApiRequest('getVerificationStatus'));
    },
    postVerification: function postVerification(id, code) {
      dispatch(performApiRequest('postVerificationToken', {}, {
        id: id,
        token: code
      }));
    },
    postOptionOrder: function postOptionOrder(orderId, projectSlug, values) {
      dispatch(performApiRequest('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }, values));
      dispatch(invalidateApiDataRequest('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }));
    },
    invalidateData: function invalidateData() {
      if (wishListId) {
        dispatch(invalidateApiDataRequest('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }
      dispatch(invalidateApiDataRequest('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch(invalidateApiDataRequest('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
    },
    openConfirmationModal: function openConfirmationModal(success) {
      dispatch(openModal(colorPalette.blue, {
        type: 'orderConfirmation',
        componentProps: {
          projectSlug: ownProps.projectSlug,
          orderId: ownProps.orderId,
          confirmed: true,
          success: success,
          categories: ownProps.categories,
          hideCloseButtons: true
        }
      }));
    },
    closeModal: function closeModal() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var ProductOptionVerificationModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionVerificationModal() {
    var _this;
    _classCallCheck(this, ProductOptionVerificationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductOptionVerificationModal, [].concat(args));
    _defineProperty(_this, "state", {
      sentSMS: false,
      codeValue: '',
      hasError: false,
      errorMessage: ''
    });
    _defineProperty(_this, "isTokenValid", function () {
      var verificationToken = _this.props.verificationToken;
      if (verificationToken) {
        return !isDateExpired(verificationToken.validUntil);
      }
      return true;
    });
    _defineProperty(_this, "handleSubmit", function () {
      var codeValue = _this.state.codeValue;
      var _this$props = _this.props,
        verificationStatus = _this$props.verificationStatus,
        postVerification = _this$props.postVerification,
        verificationToken = _this$props.verificationToken,
        postOptionOrder = _this$props.postOptionOrder,
        orderId = _this$props.orderId,
        projectSlug = _this$props.projectSlug;
      if (verificationStatus.data && verificationStatus.data.valid) {
        // IS ALREADY VERIFIED - POST ORDER
        postOptionOrder(orderId, projectSlug, {
          order_status: 'confirm_order',
          document_status: 'confirm_document',
          confirmation: true
        });
      } else if (!_this.isTokenValid()) {
        // TOKEN IS INVALID
        _this.setState({
          hasError: true,
          errorMessage: codeValue === '' ? 'De code is niet correct. Vraag een nieuwe code aan of neem contact op met de woonadviseur.' : 'De code is niet meer geldig. Vraag een nieuwe code aan of neem contact op met de woonadviseur. '
        });
      } else {
        // POST VERIFICATION TO BE CHECKED BY BACKEND
        postVerification(verificationToken.id, codeValue);
      }
    });
    _defineProperty(_this, "handleCodeInput", function (evt) {
      var el = evt.target;
      if (el) {
        _this.setState({
          codeValue: el.value
        });
      }
    });
    _defineProperty(_this, "handleSendCode", function () {
      var getVerificationToken = _this.props.getVerificationToken;
      getVerificationToken();
      _this.setState({
        codeValue: '',
        hasError: false,
        errorMessage: ''
      });
    });
    _defineProperty(_this, "handleClose", function () {
      var closeModal = _this.props.closeModal;
      closeModal();
    });
    _defineProperty(_this, "getExpiryTime", function (date) {
      var RADIX_VALUE = 10;
      var hours = parseInt(moment(date).format('H').toString(), RADIX_VALUE);
      var minutes = parseInt(moment(date).format('m').toString(), RADIX_VALUE);
      return {
        hours: hours < 10 ? "0".concat(hours) : hours.toString(),
        minutes: minutes < 10 ? "0".concat(minutes) : minutes.toString()
      };
    });
    return _this;
  }
  _inherits(ProductOptionVerificationModal, _PureComponent);
  return _createClass(ProductOptionVerificationModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getVerificationStatus = this.props.getVerificationStatus;
      getVerificationStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var sentSMS = this.state.sentSMS;
      var _this$props2 = this.props,
        verificationStatus = _this$props2.verificationStatus,
        getVerificationToken = _this$props2.getVerificationToken,
        postVerificationRequest = _this$props2.postVerificationRequest,
        postOptionOrderRequest = _this$props2.postOptionOrderRequest,
        postOptionOrder = _this$props2.postOptionOrder,
        openConfirmationModal = _this$props2.openConfirmationModal,
        orderId = _this$props2.orderId,
        projectSlug = _this$props2.projectSlug,
        invalidateData = _this$props2.invalidateData;
      if (postVerificationRequest && postVerificationRequest.networkStatus === 'success' && !postOptionOrderRequest && sentSMS) {
        // VERIFICATION SUCCEEDED - POST ORDER
        postOptionOrder(orderId, projectSlug, {
          order_status: 'confirm_order',
          document_status: 'confirm_document',
          confirmation: true
        });
      }
      if (postOptionOrderRequest && postOptionOrderRequest.networkStatus === 'success') {
        openConfirmationModal(true);
      } else if (postOptionOrderRequest && postOptionOrderRequest.networkStatus === 'failed') {
        openConfirmationModal(false);
      }
      if (postVerificationRequest && postVerificationRequest.networkStatus === 'failed') {
        // VERIFICATION FAILED
        this.setState({
          hasError: true,
          errorMessage: 'De ingevulde code is niet correct. Vraag een nieuwe code aan of neem contact op met de woonadviseur.'
        });
      } else if (postVerificationRequest && postVerificationRequest.networkStatus !== 'failed') {
        this.setState({
          hasError: false,
          errorMessage: ''
        });
      }
      if (verificationStatus.request && verificationStatus.request.networkStatus !== 'loading' && verificationStatus.data && !verificationStatus.data.valid) {
        // VERIFICATION IS INVALID
        if (!sentSMS) {
          // SEND TOKEN ONCE
          getVerificationToken();
        }
        this.setState({
          sentSMS: true
        });
      }
      onNetworkStatusChange({
        onSucces: invalidateData
      }, prevProps.postOptionOrderRequest, postOptionOrderRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        codeValue = _this$state.codeValue,
        hasError = _this$state.hasError,
        errorMessage = _this$state.errorMessage;
      var verificationStatus = this.props.verificationStatus;
      var data = verificationStatus.data;
      var verificationExpiry = null;
      if (data && data.valid) {
        verificationExpiry = this.getExpiryTime(data.validUntil);
      }
      return data ? __jsx(Container, {
        "data-id": "homestudio_ProductOptionVerificationModal_Container"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionVerificationModal_Content"
      }, __jsx(Title, {
        "data-id": "homestudio_ProductOptionVerificationModal_Title"
      }, "Onderteken om te bevestigen"), __jsx(Intro, {
        "data-id": "homestudio_ProductOptionVerificationModal_Intro"
      }, "Het maken van keuzes voor je nieuwe thuis is al spannend genoeg; dat moet je op een veilige manier kunnen doen. Daarom werken we voor het ondertekenen van de bevestiging met SMS-verificatie."), !data.valid ? __jsx(Fragment, null, __jsx(Paragraph, {
        "data-id": "homestudio_ProductOptionVerificationModal_Paragraph"
      }, "Er is een SMS verstuurd naar ", data.phone, " met een code waarmee je de bevestiging kunt ondertekenen. De verificatie is geldig tot 30 minuten na het invullen van de code. Je kunt na het ondertekenen van deze bevestiging dan ook direct doorgaan met het bevestigen van andere kopersopties."), __jsx(Paragraph, {
        "data-id": "homestudio_ProductOptionVerificationModal_Paragraph_5"
      }, "Let op: het kan tot 5 minuten duren voordat je de code ontvangt. Heb je geen code ontvangen, of is het nummer hierboven niet jouw mobiele nummer? Neem dan contact op met de woonadviseur."), __jsx(CodeContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_CodeContainer"
      }, __jsx(Input, {
        id: "verificationCode",
        name: "verificationCode",
        type: "text",
        title: "Code",
        defaultValue: codeValue,
        isValid: !hasError,
        validationMessage: hasError ? errorMessage : '',
        color: hasError ? colorPalette.red : '',
        className: hasError ? 'filled' : '',
        onChange: this.handleCodeInput,
        maxLength: 6,
        "data-id": "homestudio_ProductOptionVerificationModal_Input"
      }), __jsx(SendCodeButton, {
        hasError: hasError,
        onClick: this.handleSendCode,
        "data-id": "homestudio_ProductOptionVerificationModal_SendCodeButton"
      }, "SMS opnieuw versturen"))) : __jsx(VerifiedContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_VerifiedContainer"
      }, __jsx(CheckIcon, {
        width: 13,
        height: 10,
        "data-id": "homestudio_ProductOptionVerificationModal_CheckIcon"
      }), __jsx(VerifiedMessage, {
        "data-id": "homestudio_ProductOptionVerificationModal_VerifiedMessage"
      }, "Je hebt je identiteit reeds bevestigd door middel van SMS-verificatie. De huidige verificatie is geldig tot", ' ', verificationExpiry && "".concat(verificationExpiry.hours, ":").concat(verificationExpiry.minutes), ".")), __jsx(ButtonContainer, {
        "data-id": "homestudio_ProductOptionVerificationModal_ButtonContainer"
      }, __jsx(ButtonPrimary, {
        type: "button",
        onClick: this.handleSubmit,
        "data-id": "homestudio_ProductOptionVerificationModal_ButtonPrimary"
      }, "Bevestiging ondertekenen"), __jsx(CloseModalButton, {
        onClick: this.handleClose,
        "data-id": "homestudio_ProductOptionVerificationModal_CloseModalButton"
      }, "Sluiten zonder bevestigen")))) : null;
    }
  }]);
}(PureComponent);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(ProductOptionVerificationModal)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), colorPalette.white, shadows.boxPrimary, textStyles.bodyText);
var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 100rem 20rem;\n  "]))));
var Title = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.pageTitle, colorPalette.headerGrey);
var Intro = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.introText, colorPalette.headerGrey);
var CodeContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 40rem;\n"])));
var SendCodeButton = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  color: ", ";\n"])), function (props) {
  return props.hasError ? '30rem' : '12rem';
}, colorPalette.blue);
var VerifiedContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  margin: 0 0 40rem;\n\n  > svg {\n    flex-shrink: 0;\n    margin-right: 17rem;\n    margin-top: 8rem;\n    align-self: flex-start;\n  }\n"])));
var VerifiedMessage = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex: 1 0;\n"])));
var ButtonContainer = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n"])));
var CloseModalButton = styled.button(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n  margin-left: 24rem;\n"])), colorPalette.blue);